/**
 * @generated SignedSource<<c2c4420eeaa16663e318a22ef0944a2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleUtilsGetArticleTypeArticle$data = {
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleUtilsGetArticleTypeArticle";
};
export type articleUtilsGetArticleTypeArticle$key = {
  readonly " $data"?: articleUtilsGetArticleTypeArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleUtilsGetArticleTypeArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "articleUtilsGetArticleTypeArticle"
};

(node as any).hash = "bb2f9a4c7e0a8a1205931ed8324ccae0";

export default node;
